<template><div>
    <div class="form-group row">
        <label for="device" class="col-md-4 col-form-label text-md-right">
            {{ t.fields.current_device }}
        </label>
        <div class="col-md-6">
            <select id="device" name="current_device" class="form-control" v-model="selected_device">
                <option v-for="o in device_options" :value="o.value" :selected="o.value === selected_device">{{ o.display }}</option>
            </select>
        </div>
    </div>
    <div class="form-group row" id="deployment-time-group" v-if="selected_device != (current_device ? current_device.id : '')">
        <label for="deployment-timestamp-date" class="col-md-4 col-form-label text-md-right">
            {{ t.fields.deployment_time }}
        </label>
        <div class="col-md-6">
            <div class="input-group is-invalid">
                <input id="deployment-timestamp-date" name="deployment-timestamp[date]" type="date" class="form-control" v-bind:class="{ 'is-invalid': timestampHasError()}" v-model="date" required/>
                <input id="deployment-timestamp-time" name="deployment-timestamp[time]" type="time" class="form-control" v-bind:class="{ 'is-invalid': timestampHasError()}" v-model="time" required/>
            </div>
            <span class="invalid-feedback" role="alert" v-if="timestampHasError()">
                <strong v-for="m in [].concat(errors['deployment-timestamp.date'], errors['deployment-timestamp.time'], errors['deployment'])">
                    {{ m }}
                </strong>
            </span>
        </div>
    </div>
</div>
</template>

<script>
    import idx from 'idx'
    export default {
        props: ['t', 'device_options', 'current_device', 'errors', 'old'],
        data() {
            const d = new Date()
            return {
                selected_device: 'current_device' in this.old ? (this.old.current_device || '') : (idx(this.current_device, _ => _.id) || ''),
                date: idx(this.old, _ => _['deployment-timestamp'].date) || `${d.getFullYear()}-${("" + (d.getMonth() + 1)).padStart(2, "0")}-${("" + d.getDate()).padStart(2, "0")}`,
                time: idx(this.old, _ => _['deployment-timestamp'].time) || `${("" + d.getHours()).padStart(2, "0")}:${("" + d.getMinutes()).padStart(2, "0")}`
            }
        },
        methods: {
            timestampHasError() {
                return 'deployment-timestamp.date' in this.errors || 'deployment-timestamp.time' in this.errors || 'deployment' in this.errors
            },
        }
    }
</script>

<style scoped>

</style>
